import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResetPasswordService } from './reset-password.service';
import { ProfilePasswordFormComponent } from 'shared/profile/profile-password-form/profile-password-form.component';
import { Config } from 'shared/config/env.config';

// uncomment when add methods
// import { ProfileInfoService } from 'shared/profile/profile-info.service';


/**
 *    This class represents the lazy loaded WelcomeComponent.
 */

@Component({
  moduleId: module.id,
  selector: 'reset-password-cmp',
  templateUrl: 'reset-password.component.html',
  styleUrls: ['reset-password.component.scss'],
  // providers: [ProfileInfoService],
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('profileForm', {static: false}) profileForm: ProfilePasswordFormComponent | void;
  token: string;

  error: boolean = false;
  errorMessage: string = '';
  isCompleted: boolean = false;

  constructor(
    // private profileInfoService: ProfileInfoService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected resetPasswordService: ResetPasswordService,
  ) {}

  ngOnInit() {
    const { token } = this.route.snapshot.params;
    this.token = token;
  }

  // getters
  get form() {
    return this.profileForm ? this.profileForm.form : null;
  }

  // handlers
  onResetPasswordClick() {

    this.error = false;
    this.errorMessage = '';

    if (!this.form || this.form.invalid) { return; }

    const value = this.form.value;
    this.resetPasswordService.reset(this.token, value.newPassword, value.newPasswordConfirm)
    .subscribe( (res) => {
      if (res.success) {
        this.error = false;
        this.isCompleted = true;
      } else {
        this.error = true;
        if (res.status) {
          this.errorMessage = res.status;
        } else {
          this.errorMessage = 'We encountered an error resetting your password.';
        }
      }
    },
    (err) => {
      if (err.status === 401) {
        this.error = true;
        this.errorMessage = 'This password reset token is invalid.';
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  onLoginClick() {
    this.router.navigate(['/login']);
  }
}
